import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const addPartyAddress = (data,address_line_1, address_line_2, city, state,zip_code,country,bill_to,ship_to,install_to,extrafiledpartyaddress) => {
  return axios.post(API + "parties/add-address/"+data+"/", {
    address_line_1,
    address_line_2,
    city,
    state,
    zip_code,
    country,
    bill_to,
    ship_to,
    install_to,
    extrafiledpartyaddress
  },{headers: authHeader(),});
};
const AddPartyAddressService = {
    addPartyAddress,
  };
  export default AddPartyAddressService;